var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.88232 30.1176C1.88232 22.5979 7.99233 16.5019 15.5294 16.5019C23.0665 16.5019 29.1764 22.5979 29.1764 30.1176H1.88232ZM15.5294 12.6118C18.7595 12.6118 21.3781 9.99919 21.3781 6.77646C21.3781 3.55372 18.7595 0.941162 15.5294 0.941162C12.2992 0.941162 9.68064 3.55372 9.68064 6.77646C9.68064 9.99919 12.2992 12.6118 15.5294 12.6118Z",
    fill: "#002366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.57b15517cb3966111ca5dee6a9587062.svg";
export { ForwardRef as ReactComponent };